import { useEffect, useState } from 'react';
import {
  getInvoices,
  getActiveInvoices,
  downloadPDF,
  generateInvoice,
  commitTransacition,
  voidTransacition,
  changeStatus,
} from '../service';
// import { INVOICES } from '../constants';
import { handleAPIError } from '../../../utils/apiUtils';

const useInvoiceState = () => {
  const [invoices, setInvoices] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchInvoices = async (params = {}) => {
    try {
      setLoading(true);
      const data = await getInvoices(params);
      setInvoices(data.invoices);
      setCustomers(data.customers);
    } catch (error) {
      console.error('Failed to fetch invoices', error);
      // setInvoices(INVOICES);
    } finally {
      setLoading(false);
    }
  };

  const sortAndSetInvoices = (invoicesList) => {
    // invoicesList.sort((a, b) => {
    //   if (a.is_active !== b.is_active) {
    //     return b.is_active - a.is_active;
    //   }

    //   if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    //   if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    //   return 0;
    // });
    setInvoices(invoicesList);
  }

  const changeInvoiceStatus = async (data) => {
    let response = {
      success: false,
      code: null,
      message: null,
      data: {},
    };

    try {
      setLoading(true);
      const statusData = await changeStatus(data);
      response.success = true;
      response.data = statusData.data;
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to change invoice status', error);
    } finally {
      setLoading(false);
    }
    return response;
  }

  const commitTransacitionData = async (invoice) => {
    let response = {
      success: false,
      code: null,
      message: null,
      data: {},
    };

    try {
      setLoading(true);
      const pdf = await commitTransacition(invoice);
      response.success = true;
      response.data = pdf.data;
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to commit invoice', error);
    } finally {
      setLoading(false);
    }
    return response;
  }
  const voidTransacitionData = async (invoice) => {
    let response = {
      success: false,
      code: null,
      message: null,
      data: {},
    };

    try {
      setLoading(true);
      const pdf = await voidTransacition(invoice);
      response.success = true;
      response.data = pdf.data;
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to void invoice', error);
    } finally {
      setLoading(false);
    }
    return response;
  }

  const downloadPDFFile = async (invoice) => {
    let response = {
      success: false,
      code: null,
      message: null,
      data: {},
    };

    try {
      setLoading(true);
      const pdf = await downloadPDF(invoice);
      response.success = true;
      response.data = pdf.data;
      let fileName = 'invoice.pdf';
      const disposition = pdf.headers['content-disposition'];
      if (disposition && disposition.includes('filename=')) {
        fileName = disposition.split('filename=')[1]
                    .replace(/['"]/g, '');
      }
      response.fileName = fileName;
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to download invoice', error);
    } finally {
      setLoading(false);
    }
    return response;
  }

  const addOrUpdate = async (invoice) => {
    let response = {
      success: false,
      code: null,
      message: null,
      data: {},
    };
    try {
      setLoading(true);
      const created = await generateInvoice(invoice);
      const updatedInvoices = [...invoices, created];
      sortAndSetInvoices(updatedInvoices);
      response.success = true;
      response.data = created.data;
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update invoice', error);
    } finally {
      setLoading(false);
    }
    return response;
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return { 
    invoices,
    customers, 
    loading, 
    setInvoices,
    fetchInvoices,
    addOrUpdate, 
    downloadPDFFile, 
    commitTransacitionData, 
    voidTransacitionData, 
    changeInvoiceStatus 
  };
};

export default useInvoiceState;
